import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import syncManager from '../services/syncManager';

// Données réglementaires intégrées - Alignées avec Base44
const erp1erGroupe = {
  installations_electriques: {
    title: 'Installations électriques (EL)',
    articles: [
      { id: 'el19_2', article: 'EL19§2', text: "Absence de modification depuis la dernière vérification. Les travaux visés dans le tableau 3 doivent faire l'objet d'un RVRAT." },
      { id: 'el4_4_1', article: 'EL4§4', text: "Alimentation par la source de remplacement de l'éclairage de remplacement, des chargeurs des sources centralisées et des circuits des BAES" },
      { id: 'el4_4_2', article: 'EL4§4', text: "La défaillance de la source de remplacement entraîne le fonctionnement de l'éclairage de sécurité" },
      { id: 'el4_4_3', article: 'EL4§4', text: "BAEH associés au BAES dans les locaux à sommeil selon les conditions particulières" },
      { id: 'el5_1', article: 'EL5§1', text: "Accès des locaux de service électrique réservé aux personnes qualifiées" },
      { id: 'el5_4', article: 'EL5§4', text: "Existence de moyens d'extinction adaptés aux risques électriques dans les locaux de service électrique" },
      { id: 'el5_5', article: 'EL5§5', text: "Eclairage de sécurité des locaux de service électrique par installation fixe et par bloc autonome portable d'intervention (BAPI)" },
      { id: 'el8_3_1', article: 'EL8§3', text: "Maintien des conditions de ventilation des locaux et enveloppes contenant des batteries d'accumulateurs" },
      { id: 'el10_4', article: 'EL10§4', text: "Maintien de l'obturation selon l'article 527.2 de la NF C 15-100 du degré Coupe-Feu de traversées de parois présentant un degré CF par des canalisations électriques" },
      { id: 'el11_3_1', article: 'EL11§3', text: "Maintien de la conformité aux normes C 15-150-1 et C 15-150-2 des enseignes et tubes à décharge à HT" },
      { id: 'el11_3_2', article: 'EL11§3', text: "Classement des enveloppes supportant des enseignes" },
      { id: 'el11_4', article: 'EL11§4', text: "Dans les locaux et dégagements accessibles au public, les dispositifs de commande ou de protection non prévus pour être commandés par le public sont à 2,50m du sol ou sous la dépendance d'une clé ou d'un outil" },
      { id: 'el11_7', article: 'EL11§7', text: "Absence de fiches multiples. Prises de courant en nombre adapté pour limiter l'emploi de socles mobiles et disposées pour réduire la longueur des canalisations mobiles afin que celles-ci ne puissent pas faire obstacle à la circulation" },
      { id: 'el15_3', article: 'EL15§3', text: "Report au poste de sécurité, ou dans un emplacement non accessible au public et habituellement surveillé, de la signalisation de la coupure des dispositifs de charge des batteries d'accumulateurs alimentant des installations de sécurité et de la signalisation des défauts d'isolement signalés par les CPI sur les installations de sécurité" },
      { id: 'el8_3_2', article: 'EL8§3', text: "de la signalisation de la coupure des dispositifs de charge des batteries d'accumulateurs alimentant des installations de sécurité et de la signalisation des défauts d'isolement signalés par les CPI sur les installations de sécurité" },
      { id: 'el17', article: 'EL17', text: "Installations entretenues et maintenues en bon état de fonctionnement" },
      { id: 'el18_1_1', article: 'EL18§1', text: "Système de protection contre la foudre (paratonnerre)" },
      { id: 'el18_1_2', article: 'EL18§1', text: "Les défectuosités et les défauts d'isolement doivent être réparés dès leur constatation" },
      { id: 'el18_2', article: 'EL18§2', text: "Présence physique d'une personne qualifiée pendant la présence du public pour assurer l'exploitation et l'entretien quotidien." },
      { id: 'el18_3_1', article: 'EL18§3', text: "Maintenance et exploitation de l'éclairage de sécurité" },
      { id: 'el18_3_2', article: 'EL18§3', text: "Entretien régulier des GES et mention des essais périodiques dans un registre d'entretien tenu à la disposition de la commission de sécurité" }
    ]
  },
  eclairage_ec: {
    title: 'Éclairage (EC)',
    articles: [
      { id: 'ec5_5', article: 'EC5§5', text: "Appareils mobiles d'éclairage placés en dehors des axes de circulation et alimentés selon EL11§7 (éclairage d'appoint seulement)" },
      { id: 'ec6_5', article: 'EC6§5', text: "Appareils d'éclairage fixes ou suspendus" },
      { id: 'ec6_6', article: 'EC6§6', text: "Utilisation limitée de lampes à décharge à amorçage long (t>15s)" }
    ]
  },
  eclairage_securite: {
    title: 'Éclairage de Sécurité (EC)',
    articles: [
      { id: 'ec7_1', article: 'EC7', text: "L'éclairage de sécurité est à l'état de veille pendant l'exploitation de l'établissement." },
      { id: 'ec7_2', article: 'EC7', text: "En cas de défaillance de l'éclairage normal/remplacement, l'éclairage de sécurité est mis ou maintenu en service." },
      { id: 'ec7_3', article: 'EC7', text: "En cas de disparition de l'alimentation normal/remplacement, l'éclairage de sécurité est alimenté par une source de sécurité dont la durée de fonctionnement assignée est ≥ 1H" },
      { id: 'ec9_1', article: 'EC9§1', text: "L'éclairage d'évacuation éclaire les indications de balisage visées par l'article CO42." },
      { id: 'ec13_1', article: 'EC13', text: "Existence d'un stock de lampes de rechange pour l'éclairage de sécurité." },
      { id: 'ec13_2', article: 'EC13', text: "Notice descriptive des conditions de maintenance et de fonctionnement annexée au registre de sécurité." },
      { id: 'ec13_3', article: 'EC13', text: "Maintenance des blocs autonomes réalisée selon NF C 71-830 – Essais mensuels et semestriels par l'exploitant, maintenance et essais annuels par une personne qualifiée." },
      { id: 'ec14_3_1', article: 'EC14§3', text: "L'exploitant doit s'assurer périodiquement, une fois par mois : - Du passage à la position de fonctionnement en cas de défaillance de l'alimentation normale et à la vérification de l'allumage de toutes les lampes (le fonctionnement doit être strictement limité au temps nécessaire au contrôle visuel) ; - De l'efficacité de la commande de mise en position de repos à distance et de la remise automatique en position de veille au retour de l'alimentation normale. Ces opérations peuvent être effectuées automatiquement par l'utilisation de blocs autonomes comportant un système automatique de test intégré (SATI) conforme à la norme en vigueur. Les interventions ci-dessus et leurs résultats doivent être consignés dans le registre de sécurité." },
      { id: 'ec14_3_2', article: 'EC14§3', text: "L'exploitant doit s'assurer périodiquement, une fois tous les six mois : de l'autonomie d'au moins 1 heure. Dans les établissements comportant des périodes de fermeture, ces opérations doivent être effectuées de telle manière qu'au début de chaque période d'ouverture au public l'installation d'éclairage ait retrouvé l'autonomie prescrite. Ces opérations peuvent être effectuées automatiquement par l'utilisation de blocs autonomes comportant un système automatique de test intégré (SATI) conforme à la norme en vigueur. Les interventions ci-dessus et leurs résultats doivent être consignés dans le registre de sécurité." }
    ]
  }
};

const erp2emeGroupe = {
  regles_techniques: {
    title: 'Règles techniques (PE)',
    articles: [
      { id: 'pe9_1', article: 'PE9 §1', text: "(Arrêté du 10 octobre 2005) « Les locaux présentant des risques particuliers d'incendie associés à un potentiel calorifique important doivent être isolés des locaux et des dégagements accessibles au public dans les mêmes conditions que pour les tiers, conformément aux dispositions de l'article PE 6, § 1. Sont notamment considérés comme locaux à risques particuliers les locaux réceptacles des vide-ordures, les locaux d'extraction de la VMC inversée, les locaux contenant des groupes électrogènes, les postes de livraison et de transformation, les cellules à haute tension, les dépôts d'archives et les réserves" },
      { id: 'pe14_3', article: 'PE14 §3', text: "Le système de désenfumage naturel peut être remplacé par un système de désenfumage mécanique ; dans ce cas, il y a lieu d'appliquer les dispositions prévues dans l'instruction technique n° 246." },
      { id: 'pe15_6', article: 'PE15 §6', text: "Les circuits alimentant les appareils de cuisson doivent comporter, à proximité d'un accès au local où les appareils sont installés, un dispositif d'arrêt d'urgence de l'alimentation par énergie de l'ensemble des appareils." },
      { id: 'pe16_2', article: 'PE16 §2', text: "En ce qui concerne les grandes cuisines ouvertes : - le dispositif d'extraction de l'air vicié doit être mécanique ; - les ventilateurs d'extraction doivent pouvoir fonctionner pendant une demi-heure avec des gaz à 400° C ; - les liaisons entre le ventilateur d'extraction et le conduit doivent être en matériaux classés M0 ou A2-s1, d0 ; - (Arrêté du 21 mai 2008) « Les canalisations électriques alimentant les ventilateurs ne doivent pas être affectées par un sinistre situé dans la cuisine (ou l'îlot de cuisson défini à l'article PE 18). Il est convenu que l'utilisation de câble CR1 dans la traversée de la cuisine (ou de l'îlot de cuisson) permet de répondre à cette exigence. »" },
      { id: 'pe18_3', article: 'PE18 §3', text: "Chaque îlot de cuisson doit comporter un dispositif de captation des buées et des graisses. L'extraction est toujours mécanique et l'installation présente les caractéristiques suivantes : « Les canalisations électriques alimentant les ventilateurs ne doivent pas être affectées par un sinistre situé dans l'îlot de cuisson. Il est convenu que l'utilisation de câble CR1 dans la traversée de l'îlot de cuisson permet de répondre à cette exigence. »" },
      { id: 'pe19_1', article: 'PE19 §1', text: "L'utilisation des appareils de cuisson ou de remise en température est autorisée si la puissance utile totale est inférieure ou égale à 20 kW." },
      { id: 'pe19_2', article: 'PE19 §2', text: "En ce qui concerne les petits appareils portables, seuls sont autorisés : les appareils électriques ou à gaz de puissance utile au plus égale à 3,5 kW." }
    ]
  },
  installations_electriques: {
    title: 'Installations électriques (PE)',
    articles: [
      { id: 'pe24_1', article: 'PE24 §1', text: "Les installations électriques doivent être conformes aux normes les concernant. Les câbles ou conducteurs doivent être de la catégorie C2 selon la classification et les modalités d'attestation de conformité définies dans l'arrêté du 21 juillet 1994 portant classification et attestation de conformité du comportement au feu des conducteurs et câbles électriques et agrément des laboratoires d'essais. L'emploi de fiches multiples est interdit. Le nombre de prises de courant doit être adapté à l'utilisation pour limiter l'emploi de socles mobiles. Les prises de courant doivent être disposées de manière que les canalisations mobiles aient une longueur aussi réduite que possible et ne soient pas susceptibles de faire obstacle à la circulation des personnes." },
      { id: 'pe24_2', article: 'PE24 §2', text: "Les escaliers et les circulations horizontales d'une longueur totale supérieure à 10 mètres ou présentant un cheminement compliqué, ainsi que les salles d'une superficie supérieure à 100 mètres carrés, doivent être équipés d'une installation d'éclairage de sécurité d'évacuation. S'il est fait usage de blocs autonomes, ceux-ci doivent être conformes aux normes de la série NF C 71-800 et admis à la marque NF AEAS ou faire l'objet de toute autre certification de qualité en vigueur dans un Etat membre de la Communauté économique européenne. Cette certification devra alors présenter des garanties équivalentes à celles de la marque NF AEAS, notamment en ce qui concerne l'intervention d'une tierce partie indépendante et les performances prévues dans les normes correspondantes." },
      { id: 'pe24_3', article: 'PE24 §3', text: "Les installations électriques : - des locaux à risques particuliers tels que définis à l'article PE 9, à l'exclusion des locaux renfermant des matériels électriques dont l'accès est réservé à des personnes qualifiées chargées de l'entretien et de la surveillance de ces matériels ; - des grandes cuisines telles que définies à l'article PE 15, § 3, et des îlots de cuisson tels que définis à l'article PE 18, doivent être établies dans les conditions requises par la norme NF C 15-100 pour les locaux présentant des risques d'incendie (condition d'influence externe BE2). »" }
    ]
  },
  regles_complementaires: {
    title: 'Règles complémentaires (PE, PO, PX)',
    articles: [
      { id: 'pe36_a1', article: 'PE36 Alinéa 1', text: "Les établissements sont équipés d'un éclairage de sécurité assuré par des blocs autonomes répondant aux dispositions de l'article EC 12 ou par une source centralisée répondant aux dispositions de l'article EC 11" },
      { id: 'pe36_a2', article: 'PE36 Alinéa 2', text: "Les escaliers et les circulations horizontales sont équipés d'un éclairage d'évacuation répondant aux dispositions des articles EC 8, § 2 et EC 9." },
      { id: 'pe36_a3', article: 'PE36 Alinéa 3', text: "Dans les établissements qui ne disposent pas de groupe électrogène de remplacement, l'éclairage d'évacuation des circulations des locaux à sommeil et des dégagements attenants jusqu'à l'extérieur du bâtiment est complété de la manière suivante :\n- si l'éclairage de sécurité est réalisé par blocs autonomes, il est complété par un éclairage réalisé par des blocs autonomes pour habitation satisfaisant à l'aptitude à la fonction définie dans la norme NF C 71-805 (décembre 2000). Dans ces conditions, les blocs autonomes d'éclairage de sécurité visés à l'article EC 12 sont mis automatiquement à l'état de repos dès l'absence de tension en provenance de la source normale, leur passage à l'état de fonctionnement étant alors subordonné au début du processus de déclenchement de l'alarme ;\n- si l'éclairage de sécurité est réalisé par une source centralisée constituée d'une batterie d'accumulateurs, la capacité de cette dernière doit permettre une autonomie de six heures au moins." },
      { id: 'po13', article: 'PO13', text: "En atténuation de l'article PE 36, ces établissements sont dispensés de l'installation des blocs autonomes pour habitation (BAEH). Toutefois, si l'exploitant souhaite poursuivre l'exploitation de son établissement en l'absence de la source électrique normale, il doit disposer des moyens d'éclairage portatifs en nombre suffisant.\nL'établissement peut faire l'objet de toute solution alternative adaptée après avis de la commission de sécurité compétente." },
      { id: 'px1', article: 'PX1', text: "En complément des dispositions des chapitres Ier et II du présent livre, les dispositions techniques du chapitre XII, livre II, visant les établissements du premier groupe sont applicables aux établissements du deuxième groupe :" },
      { id: 'px1_x22', article: 'PX1 (X22)', text: "L'éclairage normal doit être fixe ou suspendu." },
      { id: 'px1_x23_1', article: 'PX1 (X23 §1)', text: "L'éclairage de sécurité de l'établissement doit répondre aux dispositions des articles EC7 à EC15." },
      { id: 'px1_x23_2', article: 'PX1 (X23 §2)', text: "L'éclairage d'ambiance des piscines est calculé sur la totalité de la surface du local, mais peut ne pas être installé au-dessus des bassins." }
    ]
  }
};

const styles = {
  container: { minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', paddingBottom: '100px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', background: 'white', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, zIndex: 100 },
  backBtn: { background: 'none', border: 'none', fontSize: '16px', color: '#3b82f6', cursor: 'pointer', padding: '8px 12px', borderRadius: '8px' },
  content: { padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' },
  
  legend: { background: 'white', borderRadius: '12px', padding: '12px 16px', display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' },
  legendItem: { padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 600 },
  legendS: { background: '#dbeafe', color: '#1e40af' },
  legendNS: { background: '#fee2e2', color: '#991b1b' },
  legendSO: { background: '#e2e8f0', color: '#475569' },
  legendNV: { background: '#fef3c7', color: '#92400e' },
  
  tabs: { display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '8px' },
  tab: { padding: '10px 16px', borderRadius: '20px', border: 'none', fontSize: '13px', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap', background: '#e2e8f0', color: '#64748b' },
  tabActive: { background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', color: 'white' },
  tabActive1er: { background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white' },
  
  card: { background: 'white', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' },
  cardHeader2eme: { padding: '14px 16px', background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)', color: 'white' },
  cardHeader1er: { padding: '14px 16px', background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white' },
  
  articleRow: { padding: '12px 16px', borderBottom: '1px solid #e2e8f0' },
  articleCode: { fontSize: '12px', fontWeight: 700, color: '#6366f1', marginBottom: '4px' },
  articleText: { fontSize: '13px', color: '#334155', lineHeight: 1.4, marginBottom: '10px' },
  articleActions: { display: 'flex', gap: '6px', flexWrap: 'wrap' },
  statusBtn: { padding: '6px 12px', borderRadius: '16px', border: '2px solid #e2e8f0', fontSize: '11px', fontWeight: 600, cursor: 'pointer', background: 'white', color: '#64748b' },
  statusBtnS: { borderColor: '#3b82f6', background: '#dbeafe', color: '#1e40af' },
  statusBtnNS: { borderColor: '#ef4444', background: '#fee2e2', color: '#991b1b' },
  statusBtnSO: { borderColor: '#64748b', background: '#e2e8f0', color: '#475569' },
  statusBtnNV: { borderColor: '#f59e0b', background: '#fef3c7', color: '#92400e' },
  
  actions: { position: 'fixed', bottom: 0, left: 0, right: 0, display: 'flex', gap: '12px', padding: '16px', background: 'white', borderTop: '1px solid #e2e8f0', boxShadow: '0 -4px 12px rgba(0,0,0,0.1)' },
  btnSecondary: { flex: 1, padding: '14px', borderRadius: '12px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', background: 'white', border: '2px solid #e2e8f0', color: '#64748b' },
  btnPrimary: { flex: 1, padding: '14px', borderRadius: '12px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', border: 'none', color: 'white' }
};

function Etape17ERPSynthese({ mission, onBack, onSave }) {
  const [erpData, setErpData] = useState({});
  const [syntheseData, setSyntheseData] = useState({});
  const [activeTab, setActiveTab] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    loadSavedData();
  }, []);

  const loadSavedData = async () => {
    try {
      const saved = await inspectionStorage.getStep(mission.id, 'rapport_erp_data');
      if (saved) {
        setErpData(saved);
        const is1erGroupe = ['1', '2', '3', '4'].includes(saved.establishment_category);
        if (is1erGroupe) {
          setSyntheseData(saved.synthese_1er_groupe || {});
          setActiveTab('installations_electriques');
        } else {
          setSyntheseData(saved.synthese_2eme_groupe || {});
          setActiveTab('regles_techniques');
        }
      }
    } catch (error) {
      console.error('Erreur chargement synthèse ERP:', error);
    }
  };

  const is1erGroupe = ['1', '2', '3', '4'].includes(erpData.establishment_category);
  const regulatoryData = is1erGroupe ? erp1erGroupe : erp2emeGroupe;
  const tabs = Object.keys(regulatoryData);

  const handleStatusChange = (tabId, articleId, status) => {
    setSyntheseData(prev => ({
      ...prev,
      [tabId]: {
        ...prev[tabId],
        [articleId]: {
          ...prev[tabId]?.[articleId],
          status: status
        }
      }
    }));
  };

  const getStatusStyle = (status) => {
    switch(status) {
      case 'S': return styles.statusBtnS;
      case 'NS': return styles.statusBtnNS;
      case 'SO': return styles.statusBtnSO;
      case 'NV': return styles.statusBtnNV;
      default: return {};
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const updatedErpData = {
        ...erpData,
        [is1erGroupe ? 'synthese_1er_groupe' : 'synthese_2eme_groupe']: syntheseData
      };

      await inspectionStorage.saveStep(mission.id, 'rapport_erp_data', updatedErpData);
      await syncManager.syncStep(mission.id, 'rapport_erp_data', updatedErpData);
      
      if (onSave) onSave(updatedErpData);
      alert('✅ Synthèse ERP sauvegardée !');
      onBack();
    } catch (error) {
      console.error('Erreur sauvegarde synthèse ERP:', error);
      alert('❌ Erreur lors de la sauvegarde');
    } finally {
      setIsSaving(false);
    }
  };

  if (!erpData.establishment_category) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <button style={styles.backBtn} onClick={onBack}>← Retour</button>
          <h1 style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: '#1e293b' }}>Étape 17 - Synthèse ERP</h1>
          <div style={{ width: '60px' }}></div>
        </div>
        <div style={{ padding: '40px 20px', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ color: '#1e293b', marginBottom: '8px' }}>Catégorie ERP non définie</h2>
          <p style={{ color: '#64748b' }}>Veuillez d'abord renseigner l'étape 16 (Informations ERP)</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: '#1e293b' }}>Étape 17</h1>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: is1erGroupe ? '#d97706' : '#7c3aed' }}>
            Synthèse ERP ({is1erGroupe ? '1er' : '2ème'} groupe)
          </p>
        </div>
        <div style={{ width: '60px' }}></div>
      </div>

      <div style={styles.content}>
        {/* Légende */}
        <div style={styles.legend}>
          <span style={{ ...styles.legendItem, ...styles.legendS }}>S : Satisfaisant</span>
          <span style={{ ...styles.legendItem, ...styles.legendNS }}>NS : Non Satisfaisant</span>
          <span style={{ ...styles.legendItem, ...styles.legendSO }}>SO : Sans Objet</span>
          <span style={{ ...styles.legendItem, ...styles.legendNV }}>NV : Non Vérifié</span>
        </div>

        {/* Tabs */}
        <div style={styles.tabs}>
          {tabs.map(tabKey => (
            <button
              key={tabKey}
              style={{
                ...styles.tab,
                ...(activeTab === tabKey ? (is1erGroupe ? styles.tabActive1er : styles.tabActive) : {})
              }}
              onClick={() => setActiveTab(tabKey)}
            >
              {regulatoryData[tabKey].title}
            </button>
          ))}
        </div>

        {/* Articles */}
        {activeTab && (
          <div style={styles.card}>
            <div style={is1erGroupe ? styles.cardHeader1er : styles.cardHeader2eme}>
              <h2 style={{ margin: 0, fontSize: '15px', fontWeight: 700 }}>
                {regulatoryData[activeTab].title}
              </h2>
            </div>
            <div>
              {regulatoryData[activeTab].articles.map((article, index) => {
                const currentStatus = syntheseData[activeTab]?.[article.id]?.status || '';
                
                return (
                  <div 
                    key={article.id} 
                    style={{
                      ...styles.articleRow,
                      borderBottom: index === regulatoryData[activeTab].articles.length - 1 ? 'none' : '1px solid #e2e8f0'
                    }}
                  >
                    <div style={styles.articleCode}>{article.article}</div>
                    <div style={styles.articleText}>{article.text}</div>
                    <div style={styles.articleActions}>
                      {['S', 'NS', 'SO', 'NV'].map(status => (
                        <button
                          key={status}
                          style={{
                            ...styles.statusBtn,
                            ...(currentStatus === status ? getStatusStyle(status) : {})
                          }}
                          onClick={() => handleStatusChange(activeTab, article.id, status)}
                        >
                          {status}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Actions */}
      <div style={styles.actions}>
        <button style={styles.btnSecondary} onClick={onBack} disabled={isSaving}>
          Annuler
        </button>
        <button 
          style={{ ...styles.btnPrimary, opacity: isSaving ? 0.6 : 1 }} 
          onClick={handleSave} 
          disabled={isSaving}
        >
          {isSaving ? '💾 Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape17ERPSynthese;